import React from 'react';
import Creative from '../components/Creative';
import PostProduction from '../components/PostProduction';

function Work() {
  return (
    <div>
     <Creative />
     <PostProduction />
    </div>
  );
}

export default Work;
